export default {"src":"/_next/static/media/report_issue.8cfac3d9.svg","height":94,"width":78,"blurWidth":0,"blurHeight":0};